import {ProposalResource} from "../../types/Proposal";
import {ModalWindow} from "../modal/ModalWindow";
import React, {useState} from "react";
import { adaptImageData } from "../../utils/IngestorConverters";

const bigImageStyle = {
    maxHeight: '100%',
    maxWidth: '100%'
}

export function ImageViewer({resources, onClose, index}:{onClose:() => void, index:number, resources:ProposalResource[]}) {
    const [showImage, setShowImage] = useState(index);

    return <ModalWindow onClose={() => onClose()}>
        <div style={{position: 'relative'}}>
            <div style={{position: 'absolute', top: 0, left: 0, height: '100%', width: '50%'}}
                 className={"pointer"}
                 onClick={() => {
                     setShowImage(showImage === 0 ? resources.length - 1 : showImage - 1);
                 }}/>
            <img alt={"source"} src={adaptImageData(resources[showImage].source, 'content', resources[showImage].content)} style={bigImageStyle}/>
            <div style={{position: 'absolute', top: 0, right: 0, height: '100%', width: '50%'}}
                 className={"pointer"}
                 onClick={() => {
                     setShowImage(showImage === resources.length - 1 ? 0 : showImage + 1);
                 }}/>
        </div>
    </ModalWindow>
}